import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../baseQuery";

const certificateTypeApi = createApi({
  reducerPath: "certificateTypeApi",
  baseQuery: baseQuery,
  tagTypes: ["CertificateType"],

  endpoints: (builder) => ({
    getCertificateTypes: builder.query<CertificateType[], void>({
      query: () => "/api/certificate_type",
      providesTags: ["CertificateType"],
    }),

    createCertificateType: builder.mutation<CertificateType, { name: string }>({
      query: (data) => ({
        url: "/api/certificate_type",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CertificateType"],
    }),

    deleteCertificateType: builder.mutation<void, { certificate_type_id: number }>({
      query: ({ certificate_type_id }) => ({
        url: `/api/certificate_type/${certificate_type_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CertificateType"],
    }),
  }),
});

export { certificateTypeApi };

export const { useGetCertificateTypesQuery, useCreateCertificateTypeMutation, useDeleteCertificateTypeMutation } =
  certificateTypeApi;
